// src/components/ConfirmModal.jsx
import React from 'react';
import './ConfirmModal.css';

export default function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText,
  onConfirm,
  onCancel,
  type = 'warning'
}) {
  
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return '🗑️';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '❓';
    }
  };

  const getColor = () => {
    switch (type) {
      case 'danger':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      case 'info':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="confirm-modal-icon" style={{ color: getColor() }}>
          {getIcon()}
        </div>

        <h2 className="confirm-modal-title">{title}</h2>

        <p className="confirm-modal-message">{message}</p>

        <div className="confirm-modal-buttons">
          {cancelText && (
            <button
              className="confirm-modal-btn confirm-modal-btn-cancel"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            className="confirm-modal-btn confirm-modal-btn-confirm"
            onClick={onConfirm}
            style={{ backgroundColor: getColor() }}
          >
            {confirmText}
          </button>
        </div>

      </div>
    </div>
  );
}